import { Input } from '@ooh/ui/components/input';
import { LabeledSearchableSelectField } from '@ooh/ui/components/labeled-searchable-select-field';
import type { SearchableSelectFieldOption as SelectOption } from '@ooh/ui/components/searchable-select-field';

export const DATE_FORMAT_CUSTOM_VALUE = 'custom';

export interface DateFormatFieldLabels {
  label: string;
  customFormatPlaceholder: string;
  customFormatHelperText: string;
}

export interface DateFormatFieldProps {
  options: SelectOption[];
  value: string;
  onChange: (next: string) => void;
  customValue: string;
  onCustomValueChange: (next: string) => void;
  labels: DateFormatFieldLabels;
  testIdPrefix?: string;
}

/**
 * Auto-detected date-format override. Reveals a free-text pattern input when
 * the operator picks the custom option (options list must include a
 * DATE_FORMAT_CUSTOM_VALUE entry), hides it again on any preset selection.
 */
export function DateFormatField({
  options,
  value,
  onChange,
  customValue,
  onCustomValueChange,
  labels,
  testIdPrefix = 'date-format',
}: DateFormatFieldProps) {
  return (
    <div className="space-y-1.5">
      <LabeledSearchableSelectField
        id={`${testIdPrefix}-select`}
        label={labels.label}
        options={options}
        value={value}
        onChange={onChange}
        testId={`${testIdPrefix}-select`}
      />
      {value === DATE_FORMAT_CUSTOM_VALUE ? (
        <div className="space-y-1 pt-1">
          <Input
            value={customValue}
            onChange={(e) => onCustomValueChange(e.target.value)}
            placeholder={labels.customFormatPlaceholder}
            data-testid={`${testIdPrefix}-custom-input`}
          />
          <p className="text-2xs text-muted-foreground">{labels.customFormatHelperText}</p>
        </div>
      ) : null}
    </div>
  );
}
